import {
  Button,
  Card,
  CardContent,
  Container,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  card: {
    maxWidth: 500,
    padding: theme.spacing(3),
    textAlign: "center",
  },
  icon: {
    fontSize: "4rem",
    color: theme.palette.warning.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
  },
  message: {
    marginBottom: theme.spacing(3),
    lineHeight: 1.6,
  },
  contactInfo: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(3),
  },
  emailLink: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  loginButton: {
    marginTop: theme.spacing(2),
  },
}));

export const AuthRequiredRoute: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  return (
    <Container className={classes.container}>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="body1" className={classes.message}>
            Hilf mit, Betrug besser zu erkennen: Spende jetzt eine kurze
            Sprachnachricht und leiste einen wertvollen Beitrag zur Forschung.
          </Typography>
          <Link to="/data-donation">
            <Button variant="contained" color="primary">
              Jetzt Audio spenden
            </Button>
          </Link>
        </CardContent>
      </Card>

      <Card className={classes.card}>
        <CardContent>
          <Icon icon="fa:lock" className={classes.icon} />

          <Typography variant="h4" className={classes.title}>
            {t("auth-required-title")}
          </Typography>

          <Typography variant="body1" className={classes.message}>
            {t("auth-required-message")}
          </Typography>

          <Box className={classes.contactInfo}>
            <Typography variant="h6" gutterBottom>
              {t("auth-need-account-title")}
            </Typography>
            <Typography variant="body2">
              {t("auth-need-account-message")}
            </Typography>
            <Typography variant="body1" style={{ marginTop: 8 }}>
              <a
                href="https://antiscam-project.de/"
                className={classes.emailLink}
              >
                {t("auth-go-to-website")}
              </a>
            </Typography>
          </Box>

          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleLoginRedirect}
            className={classes.loginButton}
          >
            {t("button-login")}
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};
